import React from 'react'
import PropTypes from 'prop-types'
import Typography from 'material-ui/Typography'

class Title extends React.PureComponent {

  static propTypes = {
    children: PropTypes.string.isRequired,
  }

  render() {
    const {children, ...props} = this.props
    return (
      <Typography variant={'headline'} align={'center'} gutterBottom={true} {...props}>{children}</Typography>
    )
  }
}

export default Title



// WEBPACK FOOTER //
// ./src/sections/flow/components/title.jsx